import { ActionReducerMap } from '@ngrx/store';
import { BasicPageState } from '../../../AppState';
import { BasicPageShapeDraftReducer } from './basic-page.reducers';


export const BasicPageReducerMapper: ActionReducerMap<BasicPageState> = {
    ShapeDraftWidgetState: BasicPageShapeDraftReducer
};
